<div class="kt-portlet kt-portlet--responsive-mobile">
  <div class="kt-portlet__head">
    <div class="kt-portlet__head-label">
      <h2 class="kt-portlet__head-title text-capitalize">
        Project Management
        <!-- | <b> Product Designs </b> -->
      </h2>
    </div>
    <div class="kt-portlet__head-toolbar">
      <div class="btn-group mr-1" role="group" aria-label="View">
        <button type="button" class="btn btn-secondary btn-sm" (click)="viewList()">
          <i class="fas fa-bars"></i>
        </button>
        <button
          type="button"
          class="btn btn-secondary btn-sm"
          (click)="viewPipelines()"
        >
          <i class="fas fa-th"></i>
        </button>
      </div>

      <button
        class="btn btn-primary btn-sm btn-create-rfq mr-1"
        (click)="createNewDesign()"
      >
        <i class="fas fa-plus"></i> Create New Task
      </button>
    </div>
  </div>

  <div class="kt-portlet__body">
    <cnc-nd-list-view *ngIf="view == 'list'"> </cnc-nd-list-view>

    <cnc-nd-pipeline-view
      *ngIf="view == 'pipeline'"
      [newDesign]="newDesign"
      (changePipeline)="setActivePipeline($event)"
    ></cnc-nd-pipeline-view>
  </div>
</div>
